import gql from 'graphql-tag';

export const DetailsPanelUserFragment = gql`
	fragment DetailsPanelUserFragment on Person {
		type
		displayName
		... on KnownUser {
			accountId
		}
		... on User {
			accountId
		}
		profilePicture {
			path
		}
	}
`;
